import AnimalDonorSearch from '../../animals/forms/search';
import { IconPlus, IconTrash } from '../../../common/icons';
import { rowRate } from '../utils/validate';

// The aspirations grid: one row per donor (cow search + total + viables + live
// rate + notes). Errors render inline per cell. Philosophy borrowed from v1's
// registers grid; UX tightened (inline validation, rate badge, sticky add).

function rateClass(rate) {
    if (rate == null) return 'opu-rate--none';
    if (rate >= 70) return 'opu-rate--good';
    if (rate >= 40) return 'opu-rate--mid';
    return 'opu-rate--low';
}

export default function AspirationRows({ rows, errors, onAdd, onField, onDonor, onClearDonor, onRemove, disabled }) {
    return (
        <div className="opu-rows">
            <div className="opu-rows__head">
                <span className="opu-rows__h opu-rows__h--donor">Donante</span>
                <span className="opu-rows__h">Óvocitos totales</span>
                <span className="opu-rows__h">Viables</span>
                <span className="opu-rows__h">Tasa</span>
                <span className="opu-rows__h opu-rows__h--notes">Notas</span>
                <span className="opu-rows__h opu-rows__h--actions" />
            </div>

            <ul className="opu-rows__list">
                {rows.map((r, i) => {
                    const e = errors[r.key] || {};
                    const rate = rowRate(r);
                    return (
                        <li key={r.key} className="opu-row">
                            <div className="opu-row__cell opu-row__cell--donor">
                                <span className="opu-row__index">{i + 1}</span>
                                <div className="opu-row__donor">
                                    <AnimalDonorSearch
                                        value={r.donor}
                                        onSelect={(a) => onDonor(r.key, a)}
                                        onClear={() => onClearDonor(r.key)}
                                        placeholder="Buscar vaca…"
                                    />
                                    {e.donor && <span className="opu-row__error" role="alert">{e.donor}</span>}
                                </div>
                            </div>

                            <div className="opu-row__cell">
                                <input
                                    type="number" min="0" inputMode="numeric"
                                    className={`opu-row__num ${e.total ? 'opu-row__num--bad' : ''}`}
                                    value={r.total}
                                    onChange={(ev) => onField(r.key, 'total', ev.target.value)}
                                    disabled={disabled}
                                    placeholder="0"
                                    aria-invalid={!!e.total}
                                />
                                {e.total && <span className="opu-row__error" role="alert">{e.total}</span>}
                            </div>

                            <div className="opu-row__cell">
                                <input
                                    type="number" min="0" inputMode="numeric"
                                    className={`opu-row__num ${e.viables ? 'opu-row__num--bad' : ''}`}
                                    value={r.viables}
                                    onChange={(ev) => onField(r.key, 'viables', ev.target.value)}
                                    disabled={disabled}
                                    placeholder="0"
                                    aria-invalid={!!e.viables}
                                />
                                {e.viables && <span className="opu-row__error" role="alert">{e.viables}</span>}
                            </div>

                            <div className="opu-row__cell opu-row__cell--rate">
                                <span className={`opu-rate ${rateClass(rate)}`}>{rate == null ? '—' : `${rate}%`}</span>
                            </div>

                            <div className="opu-row__cell opu-row__cell--notes">
                                <input
                                    type="text"
                                    className="opu-row__notes"
                                    value={r.notes}
                                    onChange={(ev) => onField(r.key, 'notes', ev.target.value)}
                                    disabled={disabled}
                                    placeholder="Opcional"
                                />
                            </div>

                            <div className="opu-row__cell opu-row__cell--actions">
                                <button
                                    type="button"
                                    className="opu-row__remove"
                                    onClick={() => onRemove(r.key)}
                                    disabled={disabled}
                                    aria-label={rows.length === 1 ? 'Limpiar fila' : 'Quitar fila'}
                                    title={rows.length === 1 ? 'Limpiar' : 'Quitar'}
                                >
                                    <IconTrash />
                                </button>
                            </div>
                        </li>
                    );
                })}
            </ul>

            <button type="button" className="opu-rows__add" onClick={onAdd} disabled={disabled}>
                <IconPlus /><span>Agregar donante</span>
            </button>
        </div>
    );
}
